import { ReactNode } from "react";

/**
 * The standard page frame: title on the left, actions on the right, content below.
 *
 * Every page hand-rolled this markup, so the header drifted -- some pages put actions in a wrapper,
 * some didn't, and the heading level and spacing were re-decided each time. Centralising it means a
 * change to page chrome happens once.
 */
export function PageShell({ title, actions, children }: { title: string; actions?: ReactNode; children: ReactNode }) {
  return (
    <div className="dashboard">
      <header className="dashboard-header">
        <h1>{title}</h1>
        {actions && <div className="header-actions">{actions}</div>}
      </header>
      {children}
    </div>
  );
}
